import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ContactFormRequest } from './contact-form.model';


@Injectable({
  providedIn: 'root'
})
export class ContactFormService {

  baseUrl = 'https://hooks.zapier.com/hooks/catch/23844768/u2qwzlt';
  constructor(private http: HttpClient) { }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
    'Access-Control-Allow-Origin': '*',
  }
  requestOptions = {
    headers: new HttpHeaders(this.headerDict),
  };
  public sendMail(data: ContactFormRequest) {
    // Only include non-empty parameters
    const payload: any = {};
    if (data.email) payload.email = data.email;
    if (data.message) payload.message = data.message;
    if (data.phone) payload.phoneNumber = data.phone;
    if (data.name) payload.name = data.name;
    return this.http.post<boolean>(this.baseUrl, payload, this.requestOptions);
  }

}
